module.exports = __webpack_public_path__ + "static/media/hotel-3.2942f272.jpg";